module.exports = __webpack_public_path__ + "img/wappin-logo-white.b98b394b.png";